import { usePage } from "@inertiajs/react"
import { filmStyle } from "@/lib/films"
import type { PageProps } from "@/types/inertia"

// The photo the admin chose in this brand's "Footer background" slot, under
// the film that section picked, so the small white copy still reads on any
// picture. Nothing at all while the slot is on its plain default — both
// footers paint bg-navy themselves.
export default function FooterBackdrop() {
  const photo = usePage<PageProps>().props.footer_photo
  if (!photo?.url) return null

  return (
    <div className="absolute inset-0" aria-hidden="true">
      <img
        src={photo.url}
        alt={photo.alt_text ?? ""}
        className="h-full w-full object-cover"
        style={{ objectPosition: "center 35%" }}
        loading="lazy"
        decoding="async"
      />
      <div className="absolute inset-0" style={{ background: filmStyle(photo.film) }} />
    </div>
  )
}
